<template>
  <div
    class="ride"
    :class="{ 'ride--link': link }"
    @click="$emit('click')"
  >
    <header class="ride__header">
      <v-layout>
        <v-flex xs8>
          <div class="ride__name text--capitalize text--ellipsis" :title="data.employee.name">
            {{ data.employee.name | textLowercase }}
          </div>

          <div class="ride__disclaimer">
            {{ $t('Common.at') }} {{ moment(data.start.date).format('H:mm') }}, {{ data.start.date | duration(data.end.date) }} mins ({{ data.odometer | metresToKm }})
          </div>
        </v-flex>

        <v-flex xs4>
          <div class="ride__value">
            <span v-if="data.chargeBack" class="success--text">
              {{ (data.fare - data.chargeBack.value) | currency  }}
            </span>
            <span v-else>{{ data.fare | currency }}</span>
          </div>
          <div v-if="data.chargeBack" class="ride__discount ride__disclaimer">
            ({{ data.fare | currencyWithoutSymbol }} - {{ data.chargeBack.value | currencyWithoutSymbol }})
          </div>
        </v-flex>
      </v-layout>
    </header>

    <v-layout>
      <v-flex class="pr-2" xs6>
        <div class="text--ellipsis" :title="data.start.address">
          {{ data.start.address }}
        </div>
        <div class="ride__disclaimer text--ellipsis">
          {{ data.start.address | getStateAndCountry }}
        </div>
      </v-flex>

      <v-icon class="ride__arrow" color="accent-2">keyboard_arrow_right</v-icon>

      <v-flex class="pl-3" xs6>
        <div class="text--ellipsis" :title="data.end.address">
          {{ data.end.address }}
        </div>
        <div class="ride__disclaimer text--ellipsis">
          {{ data.end.address | getStateAndCountry }}
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import moment from 'libs/moment'

export default {
  name: 'RideCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    link: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    moment
  }
}
</script>

<style lang="scss" scoped>
.ride {
  background-color: $white;
  color: var(--gray-7);
  padding: 16px 16px 17px;
  position: relative;
  transition: background .26s;

  &.ride--link {
    cursor: pointer;

    &:hover {
      background: rgba($black, .04);
    }
  }

  &:before {
    border-bottom: 1px solid $gray-2;
    bottom: 0;
    content: '';
    display: block;
    left: 16px;
    position: absolute;
    right: 16px;
  }
}

.ride__disclaimer {
  color: $gray-6;
  font-size: $base-font-size - 1px;
}

.ride__header {
  padding-bottom: 16px;
}

.ride__name,
.ride__value {
  font-family: $title-font;
  font-size: $base-font-size;
  font-weight: 700;
}

.ride__value {
  text-align: right;
}

.ride__discount {
  color: $success;
  font-size: $base-font-size - 1px;
  text-align: right;
}

.ride__arrow {
  bottom: 22px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}
</style>
